export default __webpack_public_path__ + "3fa93753647480ac068d1653cc844f20.svg";